import React, { useEffect } from "react";
import { Container, Tab, Tabs } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import Fancybox from "../../components/fancybox-library/fancybox";
import styles from "./css/gallery.module.css";

import { Fade, Slide, Zoom } from "react-awesome-reveal";
import "./css/gallery.css";

import { Helmet } from "react-helmet";

import Loader from "../../Loader";
import { useDispatch, useSelector } from "react-redux";
import { fetchGallery } from "../../data/gallery/gallerySlice";
import { useMediaQuery } from "@mui/material";
import { margin } from "@mui/system";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import HomeIcon from "@mui/icons-material/Home";
import { LazyLoadImage } from "react-lazy-load-image-component";
import BookingEngine from "../../components/BookingEngine";
const Gallery = () => {
  const { hotelUrl } = useParams();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(max-width:1024px)");
  const language = useSelector((state) => state.language.language);
  const { gallery, loading, error } = useSelector((state) => state.gallery);
  const { layoutHotel } = useSelector((state) => state.layoutHotel);
  useEffect(() => {
    dispatch(fetchGallery({ hotelUrl, language }));
  }, [dispatch, hotelUrl, language]);
  const groupImagesBySection = (galleries) => {
    const sections = {};

    // Ensure galleries is defined and is an array
    if (galleries && Array.isArray(galleries)) {
      galleries.forEach((image) => {
        if (!sections[image.gallerySectionName]) {
          sections[image.gallerySectionName] = [];
        }
        sections[image.gallerySectionName].push(image);
      });
    }

    return sections;
  };
  const sections = groupImagesBySection(gallery.galleries);
  return (
    <>
      {loading ? (
        <Loader />
      ) : error ? (
        <section
          style={{ backgroundColor: "#293839", padding: "200px 0 100px" }}
        >
          <h1 className="text-center text-light">{error}</h1>
        </section>
      ) : (
        <>
          <Helmet>
            <title>{gallery.pageDetails?.pageMetatagTitle}</title>
            <meta
              name="description"
              content={gallery.pageDetails?.pageMetatagDescription}
            />
          </Helmet>
          <section className="hero -type-10">
            <div
              className="hero__slider js-section-slider"
              data-gap="0"
              data-slider-cols="xl-1 lg-1 md-1 sm-1 base-1"
              data-nav-prev="js-sliderHero-prev"
              data-nav-next="js-sliderHero-next"
              data-pagination="js-sliderHero-pagination"
            >
              <div className="swiper-wrapper">
                <div className="swiper-slide">
                  <div className="hero__slide">
                    <div className="hero__bg">
                      <div className="img-ratio">
                        <LazyLoadImage
                          effect="blur"
                          src={
                            isMobile
                              ? gallery.pageDetails?.pageBannerMobile
                              : isTablet
                              ? gallery.pageDetails?.pageBannerTablet
                              : gallery.pageDetails?.pageBannerPC
                          }
                          alt={gallery.pageDetails?.pageTitle}
                          className="img-ratio"
                        />
                      </div>
                    </div>

                    <div className="hero__content text-center">
                      <div>
                        <Fade direction="up">
                          {" "}
                          <h1 className="hero__title capitalize text-white">
                            {gallery.pageDetails?.pageTitle}
                          </h1>
                        </Fade>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {layoutHotel?.hotelHeader?.hotelPMSCode ? <BookingEngine /> : null}
          </section>
          <div
            role="presentation"
            className="breadcrumbs-wrapper py-3 bg-light-1"
          >
            <div className="container-fluid">
              <Breadcrumbs aria-label="breadcrumb" className="ps-lg-4">
                <Link
                  className="d-flex align-items-center"
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  to={`/`}
                >
                  <HomeIcon
                    sx={{ mr: 0.5, fontSize: "18px" }}
                    fontSize="inherit"
                  />
                  {language === "ru"
                    ? "На главную"
                    : language === "en"
                    ? "Home"
                    : "Startseite"}
                </Link>
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="text.primary"
                  to={`/${hotelUrl}`}
                >
                  {hotelUrl === "aladdin-beach-resort"
                    ? "Aladdin Beach Resort "
                    : hotelUrl === "ali-baba-palace-hotel" ||
                      hotelUrl === "ali-baba-palace"
                    ? "Ali Baba Palace"
                    : "Jasmine Village"}
                </Link>

                <Typography
                  sx={{ display: "flex", alignItems: "center" }}
                  color="text.primary"
                >
                  {gallery.pageDetails?.pageTitle}
                </Typography>
              </Breadcrumbs>
            </div>
          </div>
          <section className="layout-pt-lg">
            <div className="container">
              <div className="row justify-center text-center">
                <div className="col-xl-6 col-lg-8 col-md-10">
                  <h2 className="text-64 md:text-40 lh-11">
                    {gallery.pageDetails?.pageTitle}
                  </h2>
                </div>
              </div>
            </div>
          </section>
          <section className="first-section py-100" id="gallery">
            <Container>
              <Tabs
                defaultActiveKey="All"
                id="gallery-tabs"
                className="d-flex  justify-content-center w-100"
              >
                <Tab
                  eventKey="All"
                  title={
                    language === "ru"
                      ? "Все"
                      : language === "en"
                      ? "All"
                      : "Alle"
                  }
                >
                  <Fancybox>
                    <div className="row mt-30">
                      <div className="d-flex  flex-wrap">
                        {gallery.galleries?.map((image, idx) => (
                          <a
                            key={idx}
                            data-fancybox="all"
                            href={image.photoFile}
                            className="esg-center eg-post-157 eg-playa-element-0 esg-transition col-12 col-lg-4 p-3 mb-3 mb-lg-0"
                          >
                            <a
                              className={`eg-playa-element-0 eg-post-157 esgbox esgboxffssii  ${styles.egplayaelement0a} `}
                              href={image.photoFile}
                            >
                              +
                            </a>
                            <Zoom duration={2000} delay={0}>
                              <LazyLoadImage
                                effect="blur"
                                alt={image.gallerySectionName}
                                src={image.photoFile}
                                style={{ width: "600px", height: "300px" }}
                              />
                            </Zoom>
                          </a>
                        ))}
                      </div>
                    </div>
                  </Fancybox>
                </Tab>
                {Object.entries(sections)?.map(
                  ([sectionName, images], index) => (
                    <Tab eventKey={sectionName} title={sectionName} key={index}>
                      <Fancybox>
                        <div className="row mt-30">
                          <div className="d-flex justify-content-center  flex-wrap">
                            {images.map((image, idx) => (
                              <a
                                key={idx}
                                data-fancybox={sectionName}
                                href={image.photoFile}
                                className="esg-center eg-post-157 eg-playa-element-0 esg-transition col-12 col-lg-4 p-3 mb-3 mb-lg-0"
                              >
                                <a
                                  className={`eg-playa-element-0 eg-post-157 esgbox esgboxffssii  ${styles.egplayaelement0a} `}
                                  href="meeting1.jpg"
                                >
                                  +
                                </a>
                                <Zoom duration={2000} delay={0}>
                                  <LazyLoadImage
                                    effect="blur"
                                    alt={image.gallerySectionName}
                                    src={image.photoFile}
                                    style={{
                                      width: "600px",
                                      height: "300px",
                                    }}
                                  />
                                </Zoom>
                              </a>
                            ))}
                          </div>
                        </div>
                      </Fancybox>
                    </Tab>
                  )
                )}
              </Tabs>
            </Container>
          </section>
        </>
      )}
    </>
  );
};
export default Gallery;
